export const LOGIN = "/sign-in"
export const SIGNUP = "/sign-up"
export const RESET = "/forgot-password"

const configuredBackendUrl =
  (typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_BACKEND_BASE_URL?.trim()) ||
  "https://api.forumone.tech"

/** In dev, route API calls through the Vite proxy to avoid ad-blocker interference. */
export const BACKEND_BASE_URL = import.meta.env.DEV ? "" : configuredBackendUrl
